import './PreventiveLinksModal.scss';

import { MenuLink } from "../../../common-components/MenuLink/MenuLink";

const PreventiveLinksModal = () => {

    return (
        <div className={"preventive-links-modal"}>
            <div className={"preventive-links-modal_container"}>
                <div className={"preventive-links-modal_items"}>
                    <MenuLink title={"Правила обеспечения промышленной безопасности для нефтяной и газовой отраслей"} link={"https://adilet.zan.kz/rus/docs/V1400010250"} active={true} show={true}/>
                    <MenuLink title={"Правила обеспечения промышленной безопасности при горных и геологоразведочных работах"} link={"https://adilet.zan.kz/rus/docs/V1400010247"} active={true} show={true}/>
                    <MenuLink title={"Правила обеспечения промышленной безопасности при взрывных работах и работе с взрывчатыми материалами"} link={"https://adilet.zan.kz/rus/docs/V1400010244"} active={true} show={true}/>
                    <MenuLink title={"Правила обеспечения промышленной безопасности при подготовке и переработке газов"} link={"https://adilet.zan.kz/rus/docs/V1400010238"} active={true} show={true}/>
                    <MenuLink title={"Правила пожарной безопасности"} link={"https://adilet.zan.kz/rus/docs/V2200026867"} active={true} show={true}/>
                </div>
            </div>
        </div>
    )
}

export default PreventiveLinksModal;